/**************************************************
 * Nombre:       Home_Experiencias
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import '@splidejs/react-splide/css';
import Tarjeta_Testimonio from "../../Tarjetas/Tarjeta_Testimonio";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {useEffect, useState} from "react";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../../Servicios/BD/obtenerColWheres";

const Home_Experiencias = () => {
    const {sCell} = useResponsive()
    const [testimonios,setTestimonios] = useState([])

    useEffect(() => {

        let w = [where('estado', '==', 'Publicado')]
        obtenerColWheres({col: 'testimonios', wheres: w}).then((dox) => {
            setTestimonios(dox.data)
        })

    }, []);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}

            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                            <Typography
                                sx={{color: theme.palette.primary.main, fontSize: 32, fontWeight: 800}}>Experiencias
                                vividas</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 5}} sx={{justifyContent: 'center', mt: 1}}>
                            <Typography
                                sx={{
                                    color: '#000',
                                    fontSize: 16,
                                    fontWeight: 300,
                                    textAlign: 'center',
                                    lineHeight: 1.2
                                }}>
                                Conoce las historias reales de quienes vivieron momentos inolvidables con nosotros.
                            </Typography>
                        </Grid>


                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                    <Splide
                        aria-label="My Favorite Images" style={{width: '100%'}}
                        options={{
                            autoplay: true,
                            speed: 5000,
                            rewind: true,
                            perPage: sCell ? 1 : 2,
                            perMove: 1,
                            arrows: true,
                            pagination: true,
                            width: '100%',
                            drag: 'false',
                            interval: 8000,
                            noDrag: true,
                            gap: 10,

                        }}
                    >

                        {testimonios.map((item, index) => {
                            return (
                                <SplideSlide key={`qe${index}`} style={{
                                    paddingRight: 60,
                                    paddingLeft: 60,
                                    paddingBottom: 60,
                                    paddingTop: 60
                                }}>
                                    <Tarjeta_Testimonio item={item}/>
                                </SplideSlide>
                            )
                        })}


                    </Splide>
                </Grid>

            </Grid>


        </Grid>
    )

}
export default Home_Experiencias

const testimonios = [1, 2, 3, 4, 5, 6]